<script setup>
import { computed } from 'vue';
import { getCalendarWeeks } from '../helpers/DatePickerHelper';
import { useI18n } from 'dashboard/composables/useI18n';

const { locale } = useI18n();

const calendarWeeks = computed(() => getCalendarWeeks(locale.value));
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in calendarWeeks"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
